import client from '../httpClient';

const userGetShareListApi = (userId, divisionId) => {
  return client.get(`/users/share-customers/${userId}?divisionId=${divisionId}`);
};

export default userGetShareListApi;
